<template>
    <div class="web_home">
        <!-- magic -->
        <div class="md_box" >
            <div class="md_top_nav" v-if="$store.state.detailsbottom">
                <img class="img_box" src="../../../assets/icons/官网首页_slices/LOGO@3x.png" alt="" srcset="">
                <img @click="opennav" class="md_nav_img" src="../../../assets/icons/官网首页_slices/菜单栏@3x.png" alt="">
            </div>
            <el-drawer
                title=""
                :visible.sync="drawer"
                size="45%">
                <div class="md_nav_list">
                    <div 
                        class="md_nav_item" 
                        :class="item.id==$store.state.mdnavaction?'nav_active':''"
                        v-for="(item,index) in mdnav" 
                        :key="index" 
                        @click="mdnavclick(item)">
                        {{ item.title }}
                    </div>
                </div>
            </el-drawer>
            <div class="md_content" ref="content">
                <mdindex 
                    :list="list"
                    :corelist="corelist"
                    :data_change="data_change"
                    @cusscroll="handleScroll" 
                    v-if="$store.state.mdnavaction==0"></mdindex>
                <mdproser  v-if="$store.state.mdnavaction==1"></mdproser>
                <mdhr  v-if="$store.state.mdnavaction==2"></mdhr>
                <mdcases v-if="$store.state.mdnavaction==3"></mdcases>
                <mdhor  v-if="$store.state.mdnavaction==4"></mdhor>
                <mdabout v-if="$store.state.mdnavaction==5"></mdabout>
            </div>
        </div>
        <flexbotton></flexbotton>
    </div>
</template>
<script>
import mdindex from './index.vue'
import mdabout from './about.vue'
import mdcases from './cases.vue'
import mdhr from './hr.vue'
import mdproser from './proser.vue'
import mdhor from './recruitment.vue'
import flexbotton from './flexbotton.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import countTo from 'vue-count-to';
import "swiper/dist/css/swiper.css";
export default{
    components: { 
        flexbotton,swiper,swiperSlide,countTo,mdindex,
        mdabout,mdcases,mdhr,mdproser,mdhor
    },
    data(){
        return{
            list:[],
            swiperOption1:{
                slidesPerView: 4,
                loop: true,
                spaceBetween:25,
                navigation: {
                    nextEl: ".swiper_left",
                    prevEl: ".swiper_right",
                }, 
                autoplay: {
                    delay: 2000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            },
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, 
                },
            },
            barlist:[
                {id:1,title:'产品与服务',path:'/proser'},
                {id:2,title:'HR数字化转型',path:'/hr'},
                {id:3,title:'服务案例',path:'/cases'},
                {id:4,title:'招聘信息',path:'/horecruitmentme'},
                {id:5,title:'关于婧贤',path:'/about'},
            ],
            botNavigationlist:[
                {title:'人力资源外包',path:'/proser',type:1,},
                {title:'劳务派遣服务',path:'/proser',type:2,},
                {title:'岗位外包服务',path:'/proser',type:3,},
                {title:'HR数字化转型',path:'/hr'},
            ],
            aboutlist:[
                {title:'产品与服务',path:'/proser'},
                {title:'服务案例',path:'/cases'},
                {title:'联系我们',path:'/about'},
            ],
            proandserlist:[
                {
                    type:1,
                    id:1,
                    path:'/proser',
                    title:'人力资源事务外包',
                    subtitle:'有效地提高效率，并使外包职能的运作更加专业化。',
                    icon:require('../../../assets/icons/官网首页_slices/hr.png'),
                    bg:require('../../../assets/icons/官网首页_slices/1.png')
                },
                {   
                    type:2,
                    id:1,
                    path:'/proser',
                    title:'劳务派遣服务',
                    subtitle:'灵活用工形式，劳动力的使用和管理分离。',
                    icon:require('../../../assets/icons/官网首页_slices/labor.png'),
                    bg:require('../../../assets/icons/官网首页_slices/2.png')
                },
                {
                    type:3,
                    id:1,
                    path:'/proser',
                    title:'岗位外包服务',
                    subtitle:'降低成本、提高效率、优化资源配置。',
                    icon:require('../../../assets/icons/官网首页_slices/post.png'),
                    bg:require('../../../assets/icons/官网首页_slices/3.png')
                },
                {
                    type:1,
                    id:2,
                    path:'/hr',
                    title:'HR数字化转型',
                    subtitle:'以颠覆性力量重构人力资源管理逻辑。',
                    icon:require('../../../assets/icons/官网首页_slices/evolve.png'),
                    bg:require('../../../assets/icons/官网首页_slices/4.png')
                },
            ],
            data_change:[
                {number: 2,title:'双城运行',littletitle: '成都拉萨双中心'},
                {number: 40,title:'服务机构',littletitle: '共计服务机构40余家'},
                {number: 9527,title:'输送人才',littletitle: '输送外包人员9千+'},
            ],
            corelist:[],
            worth:[
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_01.png'),
                    title:'使命',
                    content:'以人为本，以服务为先</br>成就人才价值，助力企业腾飞'
                },
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_02.png'),
                    title:'愿景',
                    content:'依托人才与科技</br>成为人力资源服务行业数字赋能与科技创新引领者'
                },
                {
                    icon:require('../../../assets/icons/官网首页_slices/value_03.png'),
                    title:'价值观',
                    content:'人尽其才，才尽其用'
                },
            ],
            drawer:false,
            mdnav:[
                {id:0,title:'首页'},
                {id:1,title:'产品与服务'},
                {id:2,title:'HR数字化转型'},
                {id:3,title:'服务案例'},
                {id:4,title:'招聘信息'},
                {id:5,title:'关于婧贤'},
            ],
            navaction:0,
        }
    },
    created(){
            // alert(indow.innerWidth,window.innerHeight  )
        //    alert('kuan'+window.innerWidth,'gao'+window.innerHeight )
       if(this.$store.state.mdnavaction!=null){
        this.navaction=this.$store.state.mdnavaction
       }
       this.$store.commit('mdnavaction',this.navaction)
    //   window.addEventListener('resize', this.updateWindowDimensions);
    },
    mounted(){
      this.axioslist()
        // this.navaction=this.mdnav[0].id
    },
    methods:{ 
       updateWindowDimensions() {
            //  console.log('尺寸变化',document.documentElement.clientWidth,750<document.documentElement.clientWidth&& document.documentElement.clientWidth<=1080);
            // // alert(document.documentElement.clientWidth)
            // if(750<document.documentElement.clientWidth&& document.documentElement.clientWidth<=1080){
            //     this.$router.push('/magic')
            // }else{
            //     this.$router.push('/')
            // }
       },
        handleScroll(){
            this.$refs.content.scrollTop=0
        },
        mdnavclick(item){
            this.$refs.content.scrollTop=0
            // this.navaction=item.id
            this.drawer=false
            this.$store.commit('mdnavaction',item.id)
            this.$store.commit('active',null)
        },
        opennav(){
            this.drawer=true
        },
        axioslist(){
            this.$webhttp.get('v1/web/Index').then((res)=>{
                if(res.code==200){
                    this.list=res.data.resource
                    this.corelist=res.data.casesShow
                    this.data_change=res.data.digitals
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        botNavigation(item){
              this.$router.push({
                path: item.path,
                query:{
                    type:item.type
                }
            })
        },
        seedetails(item){
            this.$store.commit('mdnavaction',item.id)
            this.$router.push({
                path: item.path,
                query:{
                    id:item.id,
                    type:item.type
                }
            })
        },
        barclick(item){
            this.$store.commit('detailsbottom',true)
            this.$store.commit('mdnavaction',item.id)
            this.$router.push({
                path: item.path,
                query:{
                    id:item.id
                }
            })
        }
    },

}
</script>
<style lang="less" scoped> 
    /deep/.el-drawer__wrapper{
        .el-drawer__container{
            .el-drawer{
                .el-drawer__header{
                    padding:25px 30px;
                    margin-bottom: 0px;
                    .el-drawer__close-btn{
                        font-size: 35px;
                        .el-dialog__close{
                            font-weight: bold;
                        }
                    }
                }
            }

        }
    }
    .web_home{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        .adaptation{
            display: none;
        }
       
        .md_box{     
            width: 100%;
            height: 100%;
            .md_content{
                box-sizing: border-box;
                height: 94.5%;
                overflow: scroll;
            }
            .md_nav_list{
                .md_nav_item{
                    height: 100px;
                    line-height: 100px;
                    padding-left: 50px;
                    font-weight: 400;
                    font-size: 35px;
                    color: #606060;
                    box-sizing: border-box;
                }
                .nav_active{
                    background: #027DFC;
                    font-weight: 400;
                    font-size: 35px;
                    color: #FFFFFF;
                }
            }
            .md_top_nav{
                position: relative;
                height: 148px;
                .img_box{
                    width: 580px;
                    height: 75px;
                    margin-top: 30px;
                    margin-left: 45px;
                }  
                .md_nav_img{
                    width: 65px;
                    height: 50px;
                    position: absolute;
                    top: 50px;
                    right: 60px;
                }
                
            }
          
        }
    
    }


</style>